import React from 'react';
import SchoolCouncil2024 from 'views/SchoolCouncil2024';

const SchoolProgrampage = () => {
  return <SchoolCouncil2024 />;
};

export default SchoolProgrampage;